import { useEffect, useSyncExternalStore } from "react";
import {
  type Command,
  getCommands,
  isPaletteOpen,
  registerCommands,
  setPaletteOpen,
  subscribeCommands,
} from "@/shared/lib/commands";

/** Reactive view of the currently registered commands. */
export function useCommands(): Command[] {
  return useSyncExternalStore(subscribeCommands, getCommands, getCommands);
}

export interface PaletteControls {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

/** Open state of the command palette + controls to drive it. */
export function usePalette(): PaletteControls {
  const open = useSyncExternalStore(subscribeCommands, isPaletteOpen, isPaletteOpen);
  return {
    open,
    setOpen: setPaletteOpen,
    toggle: () => setPaletteOpen(!isPaletteOpen()),
  };
}

/**
 * Register a feature's commands for the lifetime of the calling component.
 * Pass a memoized array (e.g. `useMemo`) so it only re-registers when commands
 * actually change.
 */
export function useRegisterCommands(commands: Command[]): void {
  useEffect(() => registerCommands(commands), [commands]);
}
